var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notification",class:_vm.type},[_c('svg',{staticClass:"voxion"},[_c('use',{attrs:{"xlink:href":"#icon-info"}})]),_c('span',{domProps:{"textContent":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }